// extracted by mini-css-extract-plugin
export default {"desiredListRow":"colleges_desiredListRow__6jGDE"};